import React from "react";
import { Navigate } from "react-router-dom";

// // Pages Component
import Chat from "../pages/Chat/Chat";

// Dashboard
import Dashboard from "../pages/Dashboard/index";
import GymDashboard from "../pages/GymDashboard/indexGym";
// Pages Calendar
import Calendar from "../pages/Calendar/index";

// //Ecommerce Pages
import EcommerceProducts from "../pages/Ecommerce/EcommerceProducts/index";
import EcommerceProductDetail from "../pages/Ecommerce/EcommerceProducts/EcommerceProductDetail";
import EcommerceOrders from "../pages/Ecommerce/EcommerceOrders/index";
import EcommerceCustomers from "../pages/Ecommerce/EcommerceCustomers/index";
import EcommerceCart from "../pages/Ecommerce/EcommerceCart";
import EcommerceCheckout from "../pages/Ecommerce/EcommerceCheckout";
import EcommerceShops from "../pages/Ecommerce/EcommerceShops/index";
import EcommerceAddProduct from "../pages/Ecommerce/EcommerceAddProduct";

//Email
import EmailInbox from "../pages/Email/email-inbox";
import EmailRead from "../pages/Email/email-read";
import EmailBasicTemplte from "../pages/Email/email-basic-templte";
import EmailAlertTemplte from "../pages/Email/email-template-alert";
import EmailTemplateBilling from "../pages/Email/email-template-billing";

//Invoices
import InvoicesList from "../pages/Invoices/invoices-list";
// import InvoiceDetail from "../pages/Invoices/invoices-detail";

//Contacts
import ContactsGrid from "../pages/Contacts/contacts-grid";
import ContactsList from "../pages/Contacts/ContactList/contacts-list";
import ContactsProfile from "../pages/Contacts/ContactsProfile/contacts-profile";

//Pages
import PagesStarter from "../pages/Utility/pages-starter";
import PagesMaintenance from "../pages/Utility/pages-maintenance";
import PagesComingsoon from "../pages/Utility/pages-comingsoon";

import PagesFaqs from "../pages/Utility/pages-faqs";
import PagesPricing from "../pages/Utility/pages-pricing";
import Pages404 from "../pages/Utility/pages-404";
import Pages500 from "../pages/Utility/pages-500";

//Ui
import UiAlert from "../pages/Ui/UiAlert";
import UiButtons from "../pages/Ui/UiButtons";
import UiCards from "../pages/Ui/UiCards";
import UiCarousel from "../pages/Ui/UiCarousel";
import UiColors from "../pages/Ui/UiColors";
import UiDropdown from "../pages/Ui/UiDropdown";
import UiGeneral from "../pages/Ui/UiGeneral";
import UiGrid from "../pages/Ui/UiGrid";
import UiImages from "../pages/Ui/UiImages";
import UiLightbox from "../pages/Ui/UiLightbox";
import UiModal from "../pages/Ui/UiModal";
import UiOffcanvas from "../pages/Ui/UiOffcanvas";
import UiProgressbar from "../pages/Ui/UiProgressbar";
import UiPlaceholders from "../pages/Ui/UiPlaceholders";
import UiTabsAccordions from "../pages/Ui/UiTabsAccordions";
import UiTypography from "../pages/Ui/UiTypography";
import UiToasts from "../pages/Ui/UiToasts";
import UiVideo from "../pages/Ui/UiVideo";
import UiSessionTimeout from "../pages/Ui/UiSessionTimeout";
import UiRating from "../pages/Ui/UiRating";
import UiRangeSlider from "../pages/Ui/UiRangeSlider";
import UiNotifications from "../pages/Ui/ui-notifications";
import UiImageCropper from "../pages/Ui/ui-image-cropper";

// Forms
import BasicElements from "../pages/Forms/BasicElements";
import FormLayouts from "../pages/Forms/FormLayouts";
import FormAdvanced from "../pages/Forms/FormAdvanced";
import FormEditors from "../pages/Forms/FormEditors";
import FormValidations from "../pages/Forms/FormValidations";
import FormMask from "../pages/Forms/FormMask";
import FormRepeater from "../pages/Forms/FormRepeater";
import FormUpload from "../pages/Forms/FormUpload";
import FormWizard from "../pages/Forms/FormWizard";
import FormXeditable from "../pages/Forms/FormXeditable";

//Tables
import BasicTables from "../pages/Tables/BasicTables";
import DatatableTables from "../pages/Tables/DatatableTables";
import ResponsiveTables from "../pages/Tables/ResponsiveTables";
import EditableTables from "../pages/Tables/EditableTables";

// Charts
import ChartApex from "../pages/Charts/Apexcharts";
import ChartjsChart from "../pages/Charts/ChartjsChart";
import EChart from "../pages/Charts/EChart";
import SparklineChart from "../pages/Charts/SparklineChart";
import ChartsKnob from "../pages/Charts/charts-knob";

//Icons

import IconUnicons from "../pages/Icons/IconUnicons";
import IconBoxicons from "../pages/Icons/IconBoxicons";
import IconDripicons from "../pages/Icons/IconDripicons";
import IconMaterialdesign from "../pages/Icons/IconMaterialdesign";
import IconFontawesome from "../pages/Icons/IconFontawesome";

// Maps
import MapsGoogle from "../pages/Maps/MapsGoogle";
import MapsVector from "../pages/Maps/MapsVector";

// File Manager
import FileManager from "../pages/FileManager";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import VerifyEmail from "../pages/Authentication/VerifyEmail";
import ResetPassword from "../pages/Authentication/ResetPassword";
import UpdatePassword from "../pages/Authentication/UpdatePassword";

//  // Inner Authentication
import Login1 from "../pages/AuthenticationInner/Login";
import Register1 from "../pages/AuthenticationInner/Register";
import Recoverpw from "../pages/AuthenticationInner/Recoverpw";
import LockScreen from "../pages/AuthenticationInner/auth-lock-screen";

// Profile
import UserProfile from "../pages/Authentication/user-profile";
import UiUtilities from "../pages/Ui/ui-utilities";

// Video
import AddVideo from "../pages/Videos/Add-Video/AddVideo";
import ListVideo from "../pages/Videos/List-Video/ListVideo";

// User
import BlockedUser from "../pages/Users/components/BlockedUser";
import ArchiveUser from "../pages/Users/components/ArchiveUser";
import ListUser from "../pages/Users/components/ListUser";
//Settings
import Setting from "../pages/Settings/ProfileSetting/Setting";
import AddPasses from "../pages/Passes//GymPasses/AddPasses";
import PassesListing from "../pages/Passes/GymPasses/PassesListing";
import PassDetail from "../pages/Passes/GymPasses/PassDetail";
import RedeemPasses from "../pages/Passes/RedeemPasses/RedeemPasses";
import RedeemPassDetail from "../pages/Passes/RedeemPasses/RedeemPassDetail";
import AddStaff from "../pages/Staff//GymsStaff/AddStaff";
import StaffListing from "../pages/Staff/GymsStaff/StaffListing";
import StaffDetail from "../pages/Staff/GymsStaff/StaffDetail";
import Payments from "../pages/Payments/GymPayments/Payments";
import AddGyms from "../pages/Gyms//components/AddGyms";
import GymsListing from "../pages/Gyms/components/GymsListing";
import GymDetails from "../pages/Gyms/components/GymDetails";
import EditGyms from "../pages/Gyms/components/EditGyms";
import AddBank from "../pages/Gyms/components/AddBank";
import AddBusinessVerification from "../pages/BusinessVerfification/AddBusinessVerification";
import BusinessVerificationListing from "../pages/BusinessVerfification/BusinessVerificationListing";
import BusinessVerificationDetails from "../pages/BusinessVerfification/BusinessVerificationDetails";
import EditBusinessVerification from "../pages/BusinessVerfification/EditBusinessVerifiaction";

import AddEquipments from "../pages/Gyms/components/AddEquipments";
import EquipListing from "../pages/Gyms/components/EquipListing";
import EquipDetail from "../pages/Gyms/components/EquipDetail";
import AddBlogs from "../pages/Blogs/components/AddBlogs";
import ListBlogs from "../pages/Blogs/components/ListBlogs";
import BlogDetails from "../pages/Blogs/components/BlogDetails";
import AddRequestFeature from "../pages/RequestFeature/components/AddRequestFeature";
import ListRequestFeature from "../pages/RequestFeature/components/ListRequestFeature";
import RequestFeatureDetails from "../pages/RequestFeature/components/RequestFeatureDetails";
import AddPrivacyPolicy from "../pages/PrivacyPolicy/components/AddPrivacyPolicy";
import ListPrivacyPolicy from "../pages/PrivacyPolicy/components/ListPrivacyPolicy";
import PrivacyPolicyDetails from "../pages/PrivacyPolicy/components/PrivacyPolicyDetails";
import AddContactUs from "../pages/ContactUs/components/AddContactUs";
import ListContactUs from "../pages/ContactUs/components/ListContactUs";
import ContactUsDetails from "../pages/ContactUs/components/ContactUsDetails";
import AddTermsCondition from "../pages/TermsCondition/components/AddTermsCondition";
import ListTermsCondition from "../pages/TermsCondition/components/ListTermsCondition";
import TermsConditionDetails from "../pages/TermsCondition/components/TermsConditionDetails";

import AddGymOwner from "../pages/Owner/GymOwner/AddGymOwner";
import GymOwnerListing from "../pages/Owner/GymOwner/GymOwnerListing";
import GymOwnerDetail from "../pages/Owner/GymOwner/GymOwnerDetail";

import GymPayout from "../pages/GymPayout/components/GymPayout";
import GymTransaction from "../pages/GymPayout/components/GymTransaction";

import AddBulk from "../pages/GymBulkUpload/GymBulk/AddBulk";
import BulkList from "../pages/GymBulkUpload/GymBulk/BulkList";

import AddFaq from "../pages/Faq/components/AddFaq";
import ListFaq from "../pages/Faq/components/ListFaq";
import FaqDetails from "../pages/Faq/components/FaqDetails";
import NotiifcationsList from "../pages/Notifications/NotificationsList";
import EditEquipment from "../pages/Gyms/components/EditEquipment";
import InvoiceDetail from "../pages/Passes/RedeemPasses/Invoice";
import BankListing from "../pages/Gyms/components/BankListing";
import GymClearance from "../pages/GymPayout/components/GymClearance";
import RedeemPass from "../pages/Authentication/RedeemPass";
import GymRatings from "../pages/Gyms/components/GymRatings";
import GymOwnerRatings from "../pages/Gyms/components/GymOwnerRatings";
import IndividualGymRatings from "../pages/Gyms/components/IndividualGymRatings";
import DeepLinkHandler from "../pages/Deeplink/Deeplink";
import GymsCategoryListing from "../pages/Gyms/components/GymsCategoryListing";
import GymsCategoryAdd from "../pages/Gyms/components/GymsCategoryAdd";
import GymsCategoryEdit from "../pages/Gyms/components/GymsCategoryEdit";
import EquipmentBrandListing from "../pages/Gyms/components/Brands/EquipmentBrandListing";
import AddEquipmentBrand from "../pages/Gyms/components/Brands/AddEquipmentBrand";
import EditEquipmentBrand from "../pages/Gyms/components/Brands/EditEquipmentBrand";
const userRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/notificationsList", component: <NotiifcationsList /> },
  { path: "/gymDashboard", component: <GymDashboard /> },
  { path: "/add-hotel", component: <AddVideo /> },
  { path: "/hotel-listing", component: <ListVideo /> },
  { path: "/blocked-users", component: <BlockedUser /> },
  { path: "/archive-users", component: <ArchiveUser /> },
  { path: "/list-users", component: <ListUser /> },
  { path: "/profile-setting", component: <Setting /> },
  { path: "/add-passes", component: <AddPasses /> },
  { path: "/list-passes", component: <PassesListing /> },
  { path: "/gym-ratings", component: <GymRatings /> },
  { path: "/gym-owner-ratings", component: <GymOwnerRatings /> },
  { path: "/individual-gym-ratings", component: <IndividualGymRatings /> },
  { path: "/pass-detail", component: <PassDetail /> },
  { path: "/redeem-passes", component: <RedeemPasses /> },
  { path: "/redeem-pass-detail", component: <RedeemPassDetail /> },
  { path: "/add-staff", component: <AddStaff /> },
  { path: "/list-staff", component: <StaffListing /> },
  { path: "/staff-Detail", component: <StaffDetail /> },
  { path: "/gym-payments", component: <Payments /> },
  { path: "/add-gyms", component: <AddGyms /> },
  { path: "/gym-details/:id", component: <GymDetails /> },
  { path: "/list-gyms", component: <GymsListing /> },
  { path: "/edit-gyms/:id", component: <EditGyms /> },
  { path: "/add-bank", component: <AddBank /> },
  { path: "/list-bank", component: <BankListing /> },
  { path: "/redeem-invoice", component: <InvoiceDetail /> },
  { path: "/gym-category", component: <GymsCategoryListing /> },
  { path: "/add-category", component: <GymsCategoryAdd /> },
  { path: "/edit-category/:id", component: <GymsCategoryEdit /> },
  { path: "/view-equipment-brand", component: <EquipmentBrandListing/> },
  { path: "/add-equipment-brand", component: <AddEquipmentBrand/> },
  { path: "/edit-equipment-brand/:id", component: <EditEquipmentBrand /> },
  {
    path: "/add-businessverification/:id",
    component: <AddBusinessVerification />,
  },
  {
    path: "/businessverification-details/:id",
    component: <BusinessVerificationDetails />,
  },
  {
    path: "/list-businessverification",
    component: <BusinessVerificationListing />,
  },
  {
    path: "/edit-businessverification/:id",
    component: <EditBusinessVerification />,
  },
  { path: "/add-equip/", component: <AddEquipments /> },
  { path: "/edit-equip/:id", component: <EditEquipment /> },
  { path: "/equip-listing", component: <EquipListing /> },
  { path: "/equip-detail", component: <EquipDetail /> },
  { path: "/add-blog", component: <AddBlogs /> },
  { path: "/list-blog", component: <ListBlogs /> },
  { path: "/blog-details", component: <BlogDetails /> },
  { path: "/add-bulk", component: <AddBulk /> },
  { path: "/add-gymowner", component: <AddGymOwner /> },
  { path: "/list-gymowner", component: <GymOwnerListing /> },
  { path: "/gymowner-Detail", component: <GymOwnerDetail /> },
  { path: "/gym-payout", component: <GymPayout /> },
  { path: "/transaction", component: <GymTransaction /> },
  { path: "/clearance", component: <GymClearance /> },
  { path: "/add-requestfeature", component: <AddRequestFeature /> },
  { path: "/list-requestfeature", component: <ListRequestFeature /> },
  { path: "/requestfeature-details", component: <RequestFeatureDetails /> },
  { path: "/add-privacypolicy", component: <AddPrivacyPolicy /> },
  { path: "/list-privacypolicy", component: <ListPrivacyPolicy /> },
  { path: "/privacypolicy-details", component: <PrivacyPolicyDetails /> },

  { path: "/add-termscondition", component: <AddTermsCondition /> },
  { path: "/list-termscondition", component: <ListTermsCondition /> },
  { path: "/termscondition-details", component: <TermsConditionDetails /> },

  { path: "/add-contactus", component: <AddContactUs /> },
  { path: "/list-contactus", component: <ListContactUs /> },
  { path: "/contactus-details", component: <ContactUsDetails /> },

  { path: "/add-faq", component: <AddFaq /> },
  { path: "/list-faq", component: <ListFaq /> },
  { path: "/faq-details", component: <FaqDetails /> },

  { path: "/calendar", component: <Calendar /> },
  //chat
  { path: "/chat", component: <Chat /> },

  //Ecommerce
  { path: "/ecommerce-products", component: <EcommerceProducts /> },
  { path: "/ecommerce-product-detail", component: <EcommerceProductDetail /> },
  {
    path: "/ecommerce-products-detail/:id",
    component: <EcommerceProductDetail />,
  },
  { path: "/ecommerce-orders", component: <EcommerceOrders /> },
  { path: "/ecommerce-customers", component: <EcommerceCustomers /> },
  { path: "/ecommerce-cart", component: <EcommerceCart /> },
  { path: "/ecommerce-checkout", component: <EcommerceCheckout /> },
  { path: "/ecommerce-shops", component: <EcommerceShops /> },
  { path: "/ecommerce-add-product", component: <EcommerceAddProduct /> },

  //Email
  { path: "/email-inbox", component: <EmailInbox /> },
  { path: "/email-read", component: <EmailRead /> },
  { path: "/email-template-basic", component: <EmailBasicTemplte /> },
  { path: "/email-template-alert", component: <EmailAlertTemplte /> },
  { path: "/email-template-billing", component: <EmailTemplateBilling /> },

  //Invoices
  { path: "/invoices-list", component: <InvoicesList /> },
  // { path: "/invoices-detail", component: <InvoiceDetail /> },
  // { path: "/invoices-detail/:id", component: <InvoiceDetail /> },

  // Contacts
  { path: "/contacts-grid", component: <ContactsGrid /> },
  { path: "/contacts-list", component: <ContactsList /> },
  { path: "/contacts-profile", component: <ContactsProfile /> },

  //Utility
  { path: "/pages-starter", component: <PagesStarter /> },

  { path: "/pages-faqs", component: <PagesFaqs /> },
  { path: "/pages-pricing", component: <PagesPricing /> },

  // Ui
  { path: "/ui-alerts", component: <UiAlert /> },
  { path: "/ui-buttons", component: <UiButtons /> },
  { path: "/ui-cards", component: <UiCards /> },
  { path: "/ui-carousel", component: <UiCarousel /> },
  { path: "/ui-colors", component: <UiColors /> },
  { path: "/ui-dropdowns", component: <UiDropdown /> },
  { path: "/ui-general", component: <UiGeneral /> },
  { path: "/ui-grid", component: <UiGrid /> },
  { path: "/ui-images", component: <UiImages /> },
  { path: "/ui-lightbox", component: <UiLightbox /> },
  { path: "/ui-modals", component: <UiModal /> },
  { path: "/ui-offcanvas", component: <UiOffcanvas /> },
  { path: "/ui-progressbars", component: <UiProgressbar /> },
  { path: "/ui-placeholders", component: <UiPlaceholders /> },
  { path: "/ui-tabs-accordions", component: <UiTabsAccordions /> },
  { path: "/ui-typography", component: <UiTypography /> },
  { path: "/ui-toasts", component: <UiToasts /> },
  { path: "/ui-video", component: <UiVideo /> },
  { path: "/ui-session-timeout", component: <UiSessionTimeout /> },
  { path: "/ui-rating", component: <UiRating /> },
  { path: "/ui-rangeslider", component: <UiRangeSlider /> },
  { path: "/ui-notifications", component: <UiNotifications /> },
  { path: "/ui-image-cropper", component: <UiImageCropper /> },
  { path: "/ui-utilities", component: <UiUtilities /> },

  // Forms
  { path: "/basic-elements", component: <BasicElements /> },
  { path: "/form-layouts", component: <FormLayouts /> },
  { path: "/form-advanced", component: <FormAdvanced /> },
  { path: "/form-editors", component: <FormEditors /> },
  { path: "/form-mask", component: <FormMask /> },
  { path: "/form-repeater", component: <FormRepeater /> },
  { path: "/form-uploads", component: <FormUpload /> },
  { path: "/form-wizard", component: <FormWizard /> },
  { path: "/form-validation", component: <FormValidations /> },
  { path: "/form-xeditable", component: <FormXeditable /> },

  // Tables
  { path: "/tables-basic", component: <BasicTables /> },
  { path: "/tables-datatable", component: <DatatableTables /> },
  { path: "/tables-responsive", component: <ResponsiveTables /> },
  { path: "/tables-editable", component: <EditableTables /> },

  //Charts
  { path: "/apex-charts", component: <ChartApex /> },
  { path: "/chartjs-charts", component: <ChartjsChart /> },
  { path: "/e-charts", component: <EChart /> },
  { path: "/sparkline-charts", component: <SparklineChart /> },
  { path: "/charts-knob", component: <ChartsKnob /> },

  // Icons
  { path: "/icons-unicons", component: <IconUnicons /> },
  { path: "/icons-boxicons", component: <IconBoxicons /> },
  { path: "/icons-dripicons", component: <IconDripicons /> },
  { path: "/icons-materialdesign", component: <IconMaterialdesign /> },
  { path: "/icons-fontawesome", component: <IconFontawesome /> },

  // Maps
  { path: "/maps-google", component: <MapsGoogle /> },
  { path: "/maps-vector", component: <MapsVector /> },

  // File Manager
  { path: "/file-manager", component: <FileManager /> },

  // //profile
  { path: "/profile", component: <UserProfile /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  { path: "*", component: <Navigate to="/dashboard" /> },
];

const authRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/elevated/GymDetails/:id", component: <DeepLinkHandler /> },
  { path: "/elevated/ProfileSetting/:id", component: <DeepLinkHandler /> },
  { path: "/redeemPass", component: <RedeemPass /> },
  { path: "/verify-email", component: <VerifyEmail /> },
  { path: "/register", component: <Register /> },
  { path: "/reset-password", component: <ResetPassword /> },
  { path: "/update-password", component: <UpdatePassword /> },

  { path: "/pages-maintenance", component: <PagesMaintenance /> },
  { path: "/pages-comingsoon", component: <PagesComingsoon /> },
  { path: "/pages-404", component: <Pages404 /> },
  { path: "/pages-500", component: <Pages500 /> },

  // Authentication Inner
  { path: "/pages-login", component: <Login1 /> },
  { path: "/pages-register", component: <Register1 /> },
  { path: "/page-recoverpw", component: <Recoverpw /> },
  { path: "/auth-lock-screen", component: <LockScreen /> },
];

export { userRoutes, authRoutes };
